import React, { useEffect, useState } from 'react'
import {
  Button,
  Modal,
  Pagination,
  Tabs,
  Dropdown,
  Menu,
  Tag,
  Tooltip,
  Card,
  Popconfirm,
  Input,
  DatePicker,
  Row,
  Col,
  Form,
  Select,
  message,
} from 'antd'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch, useAppSelector } from '~/Store/hooks'
import { UserActions } from '~/Store/User'
import { ListLisencesIdDelete, UserService } from '~/Services'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import localeData from 'dayjs/plugin/localeData'
import utc from 'dayjs/plugin/utc'
import {
  DeleteOutlined,
  EditOutlined,
  CaretDownOutlined,
  InfoCircleOutlined,
  GiftOutlined,
  MoreOutlined,
  PlusCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons'
import './AdminOrganizations.css'
import Title from 'antd/lib/skeleton/Title'
import { getLicenseTypes, LicenseMgmtActions } from '~/Store/License'
import { stat } from 'fs'

dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.locale('en')
dayjs.locale('vi')
dayjs.extend(utc)
export const AdminOrganizations = () => {
  const dispatch = useAppDispatch()
  const dataorga = useSelector(
    (state: RootState) => state.user.listOrganizationData,
  )
  const lisencesData = useSelector((state: RootState) => state.user.lisenceData)
  console.log('lisencesData', lisencesData)
  const licenseTypes = useAppSelector(getLicenseTypes)
  //console.log('licenseTypes licenseTypes', licenseTypes)

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [currentRecord, setCurrentRecord] = useState<any>(null)
  //console.log('currentRecord', currentRecord)
  const userId = currentRecord?.license
  //console.log('userId', userId)
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 10

  const [usersList, setUsersList] = useState<string[]>([])
  const [isUsersModalVisible, setIsUsersModalVisible] = useState(false)
  const [currentLicense, setCurrentLicense] = useState<any>(null)
  const [newLicense, setNewLicense] = useState('')
  const [orgID, setOrgID] = useState('')
  const [isAddingLicense, setIsAddingLicense] = useState(false)
  const [usersData, setUsersData] = useState<any>(null)
  const [inputValue, setInputValue] = useState(0)
  //console.log('inputValue', inputValue)

  if (typeof ResizeObserver !== 'undefined') {
    const resizeObserver = new ResizeObserver(() => {})
    resizeObserver.observe(document.body)
  }
  const [isLicenseExists, setIsLicenseExists] = useState(false)

  const handleLicenseChange = value => {
    //console.log('Đang chọn License với guid:', value)
    const licenseDetails = lisencesData?.map(license => ({
      guid: license.licenseType.guid,
      name: license.licenseType.name,
    }))
    const isLicenseExists = licenseDetails.some(
      license => license.guid === value,
    )
    if (isLicenseExists) {
      //console.log('License đã tồn tại')
      message.error('License đã tồn tại')
    }
    setIsLicenseExists(isLicenseExists)
  }

  const fetchListOrganization = async () => {
    try {
      dispatch(UserActions.getListOrganizationDataRequest())
      const req: any = await UserService.Get.getListOrganization()
      const { data } = req
      dispatch(UserActions.setListOrganizationDataSuccess(data))
    } catch (err) {
      console.error('Error fetching organization list:', err)
      dispatch(UserActions.setListOrganizationDataFailure(err))
    }
  }

  useEffect(() => {
    fetchListOrganization()
  }, [dispatch])

  const dataSource =
    dataorga?.results.map((org: any) => ({
      key: org.guid,
      companyName: org.companyName,
      billingAddress: org.billingAddress,
      billingAddress2: org.billingAddress2,
      billingCity: org.billingCity,
      billingState: org.billingState,
      billingZip: org.billingZip,
      crmId: org.crmId,
      duns: org.duns,
      naics: org.naics,
      userOrganization: org.userOrganization,
      licenses: org.licenses,
      organizationRoles: org.organizationRoles,
      status: org.status,
    })) || []

  const paginatedData = dataSource.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  )

  const handleModalOk = () => {
    //console.log('Updated record:', currentRecord)
    setIsModalVisible(false)
  }

  const handleModalCancel = () => {
    setIsModalVisible(false)
    setCurrentRecord(null)
  }

  const handleEdit = async (record: any) => {
    console.log('Edit record:', record)
    try {
      dispatch(UserActions.searchUserRequest())
      const reqUsers: any = await UserService.Get.getUsersByOrganization(
        record.key,
      )
      const { data: usersData } = reqUsers
      dispatch(UserActions.searchUserSuccess(usersData))
      //console.log('Fetched users by organization:', usersData)
      setUsersData(usersData?.results)
      setOrgID(record.key)
      dispatch(UserActions.getLisencesRequest())
      const req: any = await UserService.Get.getLicensesById(record.key)
      const { data } = req

      dispatch(UserActions.setLisencesSuccess(data))
      //console.log('Fetched licenses:', data)

      const formattedLicenses = data.map((license: any) => ({
        ...license,
        licenseName: license.licenseType?.name,
        users: license.users.map((user: any) => ({
          name: user.email,
          id: user.id,
        })),
      }))

      setCurrentRecord({
        ...record,
        licenses: formattedLicenses,
      })
    } catch (err) {
      console.error('Error fetching licenses:', err)
    }

    setIsModalVisible(true)
  }

  const handleDelete = async (user: any) => {
    //console.log('Delete record:', user)
    try {
      dispatch(UserActions.deleteRequest())
      const input = [userId]
      const req: any = await UserService.Delete.deleteUser(user.id, input)

      if (req === 1) {
        const updatedLicenses = currentRecord?.licenses?.filter(
          (license: any) => license.users.every((u: any) => u.id !== user.id),
        )
        setCurrentRecord({
          ...currentRecord,
          licenses: updatedLicenses,
        })
      } else if (req === -1) {
        console.error('Error deleting user: Operation failed')
      } else {
        console.error('Unexpected API response:', req)
      }
    } catch (err) {
      console.error('Error deleting user:', err)
    }
  }

  const showRecordDetails = async (record: any) => {
    console.log('record.key', record.key)
    try {
      dispatch(UserActions.searchUserRequest())
      const reqUsers: any = await UserService.Get.getUsersByOrganization(
        record.key,
      )
      const { data: usersData } = reqUsers
      dispatch(UserActions.searchUserSuccess(usersData))
      setUsersData(usersData?.results)

      dispatch(UserActions.getLisencesRequest())
      const req: any = await UserService.Get.getLicensesById(record.key)
      setOrgID(record.key)
      const { data } = req

      dispatch(UserActions.setLisencesSuccess(data))
      const formattedLicenses = data.map((license: any) => ({
        ...license,
        licenseName: license.licenseType?.name,
        users: license.users.map((user: any) => ({
          name: user.email,
          id: user.id,
        })),
      }))

      setCurrentRecord({
        ...record,
        licenses: formattedLicenses,
      })
    } catch (err) {
      console.error('Error fetching licenses:', err)
    }
    setIsModalVisible(true)
  }

  const showUsersList = (users: string[], license: any) => {
    setInputValue(license.number)
    setUsersList(users)
    setCurrentLicense(license)
    setIsUsersModalVisible(true)
  }

  const handleUsersModalCancel = () => {
    setIsUsersModalVisible(false)
  }

  const handleAddLicense = () => {
    setIsAddingLicense(true)
  }

  const handleSaveLicense = () => {
    if (newLicense.trim()) {
      //console.log('New License Added:', newLicense)
      setIsAddingLicense(false)
      setNewLicense('')
    } else {
      alert('Please enter a license name')
    }
  }

  const formatDate = (date: string) => {
    return dayjs(date).format('DD/MM/YYYY')
  }

  const handleDateChange = (date: any) => {
    if (currentLicense) {
      setCurrentLicense({
        ...currentLicense,
        expiredate: date ? date.local().format('YYYY-MM-DD') : null,
      })
    }
  }

  const handleCloseAddLicense = () => {
    setIsAddingLicense(false)
    setNewLicense('')
  }

  const handleUpdateExpireDate = async () => {
    if (!currentLicense) {
      console.error('No license data available for update')
      return
    }
    try {
      const updatedExpireDate = currentLicense?.expiredate
      const activeDate = currentLicense.activeDate || dayjs().toISOString()
      const licenseTypeId =
        currentLicense.licenseTypeId || 'default-license-type-id'
      const limitDevices = currentLicense.limitDevices || 0
      const number = inputValue || 0

      const input = [
        {
          expiredate: updatedExpireDate,
          licenseTypeId: licenseTypeId,
          activeDate: activeDate,
          limitDevices: limitDevices,
          number: number,
        },
      ]
      const orgId = currentLicense.organizationId
      const req: any = await UserService.Put.updateDateLicense(orgId, input)
      dispatch(UserActions.getLisencesRequest())

      setIsModalVisible(false)
    } catch (err) {
      console.error('Error updating license expiration date:', err)
    }
    setIsUsersModalVisible(false)
  }

  const getInvitationStatusColor = (status: string) => {
    switch (status) {
      case 'Accepted':
        return 'green'
      case 'Pending':
        return 'red'
      case 'Declined':
        return 'blue'
      default:
        return 'black'
    }
  }

  const getRoleColor = (role: string) => {
    switch (role) {
      case 'Member':
        return '#28a745'
      case 'Admin':
        return '#dc3545'
      case 'SuperUser':
        return '#007bff'
      case 'Leader':
        return '#ffc107'
      default:
        return '#6c757d'
    }
  }


  const verifyNullStatus = (status: string | null | undefined): string => {
    if (status === null || status === undefined) {
      return 'None';
    }
    return status;
  };
  
  


  const handleInputChange = e => {
    const value = e.target.value
    console.log('value ', value)
    setInputValue(Number(value))
  }

  const [newLicenseModalVisible, setNewLicenseModalVisible] = useState(false)

  const addNewLicense = () => {
    dispatch(
      LicenseMgmtActions.getLicenseTypes({
        paging: true,
        pageSize: 1000,
        page: 1,
      }),
    )
    setNewLicenseModalVisible(true)
  }

  const cancelNewLicense = () => {
    setNewLicenseModalVisible(false)
  }

  const handleNewLicenseOk = async (record: any) => {
    console.log('handleNewLicenseOk record:', record)

    if (!record || typeof record !== 'object') {
      console.error('record phải là đối tượng')
      return
    }

    const input = [
      {
        expiredate: record.endDate.toISOString(),
        licenseTypeId: record.licenseName,
        activeDate: record.startDate.toISOString(),
        limitDevices: parseInt(record.userCount),
        number: parseInt(record.userCount),
      },
    ]

    try {
      dispatch(UserActions.createNewLisencesRequest())
      const req: any = await UserService.Post.createNewLicense(orgID, input)
    } catch (err) {
      console.error('Error fetching licenses:', err)
    }
    setNewLicenseModalVisible(false)
    setIsModalVisible(false)
  }

  return (
    <div className="AdminOrganizations-container">
      <div className="table-container">
        {paginatedData.map(item => (
          <div
            key={item.key}
            className="table-row"
            onClick={() => showRecordDetails(item)}
          >
            <div className="table-cell">{item.companyName || ''}</div>
            <div className="table-cell">{item.billingAddress || ''}</div>
            <div className="table-cell">{item.crmId || ''}</div>
            <div className="table-cell">{item.duns || ''}</div>
            <div className="table-cell">{item.naics || ''}</div>
            <div className="table-cell">{item.organizationRoles || ''}</div>
            <div className="table-cell status">
              <span className={`status ${item.status}`}>
                {verifyNullStatus(item.status)}
              </span>
            </div>
            <div className="table-cell actions">
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={e => {
                  e.stopPropagation()
                  handleEdit(item)
                }}
              />
              <Button
                type="link"
                icon={<DeleteOutlined />}
                danger
                onClick={e => {
                  e.stopPropagation()
                  // handleDelete(item)
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <Pagination
        style={{ textAlign: 'center' }}
        current={currentPage}
        pageSize={pageSize}
        total={dataSource.length}
        onChange={page => setCurrentPage(page)}
      />

      <Modal
        visible={isModalVisible}
        className="custom-modal"
        footer={null}
        maskClosable={true}
        onCancel={() => setIsModalVisible(false)}
      >
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Thông tin chi tiết" key="1">
            <div
              className="custom-modal-content"
              style={{
                padding: '20px',
                backgroundColor: '#fafafa',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              }}
            >
              <p
                style={{
                  marginBottom: '15px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                }}
              >
                Thông tin chi tiết:
              </p>
              <div
                style={{ lineHeight: '1.8', fontSize: '14px', color: '#555' }}
              >
                <p>
                  <strong>Họ và tên:</strong>{' '}
                  <span style={{ color: '#333' }}>
                    {currentRecord?.companyName || ''}
                  </span>
                </p>
                <p>
                  <strong>Thành phố:</strong>{' '}
                  <span style={{ color: '#333' }}>
                    {currentRecord?.billingCity || ''}
                  </span>
                </p>
                <p>
                  <strong>CCCD:</strong>{' '}
                  <span style={{ color: '#333' }}>
                    {currentRecord?.crmId || ''}
                  </span>
                </p>
                <p>
                  <strong>SDT:</strong>{' '}
                  <span style={{ color: '#333' }}>
                    {currentRecord?.duns || ''}
                  </span>
                </p>
                <p>
                  <strong>Công việc:</strong>{' '}
                  <span style={{ color: '#333' }}>
                    {currentRecord?.naics || ''}
                  </span>
                </p>
                <p>
                  <strong>Địa chỉ nhà:</strong>{' '}
                  <span style={{ color: '#333' }}>
                    {currentRecord?.billingAddress || ''}
                  </span>
                </p>
                <p>
                  <strong>Địa chỉ công ty:</strong>{' '}
                  <span style={{ color: '#333' }}>
                    {currentRecord?.billingAddress2 || ''}
                  </span>
                </p>
              </div>
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab="User" key="2">
            {usersData ? (
              <div className="table-container">
                {usersData.map((user: any) => (
                  <div key={user.id}>
                    <div className="table-row">
                      <div className="table-cell">{`${user.lastname} ${user.firstname}`}</div>
                      <div className="table-cell">{user.email}</div>
                      <div
                        className="table-cell"
                        style={{
                          display: 'flex',
                          gap: '8px',
                          flexWrap: 'wrap',
                        }}
                      >
                        {user.organizationRoles.map((role: string) => (
                          <div
                            key={role}
                            style={{
                              color: getRoleColor(role),
                            }}
                          >
                            {role}
                          </div>
                        ))}
                      </div>{' '}
                      <div
                        style={{
                          color: getInvitationStatusColor(
                            user.invitationStatus,
                          ),
                        }}
                      >
                        {user.invitationStatus || ''}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>Loading users...</p>
            )}
          </Tabs.TabPane>

          <Tabs.TabPane tab="Licenses" key="3">
            <div
              className="licenses-tab-content"
              style={{ padding: '0 20px 20px 20px' }}
            >
              <p
                style={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                Danh sách các Licenses:
                <PlusCircleOutlined
                  style={{ marginRight: '8px' }}
                  onClick={addNewLicense}
                />
              </p>
              {Array.isArray(currentRecord?.licenses) &&
              currentRecord?.licenses.length > 0 ? (
                <div
                  className="licenses-list"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '15px',
                  }}
                >
                  {currentRecord?.licenses.map(
                    (license: any, index: number) => (
                      <Tag
                        key={index}
                        className="license-tag"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '10px 15px',
                          borderRadius: '8px',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                          backgroundColor: '#fafafa',
                          border: '1px solid #d9d9d9',
                        }}
                      >
                        <GiftOutlined
                          style={{
                            fontSize: '35px',
                            color: 'red',
                            marginRight: '15px',
                          }}
                        />
                        <div
                          style={{
                            flex: 1,
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          <span
                            style={{
                              fontSize: '14px',
                              fontWeight: 'bold',
                              color: '#333',
                            }}
                          >
                            {license?.licenseName} ({license?.number} users)
                          </span>
                        </div>
                        <Tooltip title="License Info">
                          <InfoCircleOutlined
                            style={{
                              cursor: 'pointer',
                              color: 'red',
                              fontSize: '18px',
                              marginLeft: '10px',
                            }}
                            onClick={() =>
                              showUsersList(license.users, license)
                            }
                          />
                        </Tooltip>
                      </Tag>
                    ),
                  )}
                </div>
              ) : (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '20px',
                    backgroundColor: '#f9f9f9',
                    borderRadius: '8px',
                    border: '1px dashed #d9d9d9',
                    fontSize: '14px',
                    color: '#888',
                  }}
                >
                  <span>Không có licenses</span>
                </div>
              )}
              <Modal
                title="Thêm mới License"
                visible={newLicenseModalVisible}
                onCancel={cancelNewLicense}
                footer={null}
              >
                <Form layout="vertical" onFinish={handleNewLicenseOk}>
                  <Form.Item
                    label="Tên License"
                    name="licenseName"
                    rules={[
                      { required: true, message: 'Vui lòng chọn tên License!' },
                    ]}
                  >
                    <Select
                      placeholder="Chọn License"
                      onChange={handleLicenseChange}
                    >
                      {licenseTypes.map(license => (
                        <Select.Option key={license.guid} value={license.guid}>
                          {license.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="Số lượng users"
                    name="userCount"
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng nhập số lượng users!',
                      },
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>

                  <Form.Item
                    label="Ngày bắt đầu"
                    name="startDate"
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng chọn ngày bắt đầu!',
                      },
                    ]}
                  >
                    <DatePicker style={{ width: '100%' }} />
                  </Form.Item>

                  <Form.Item
                    label="Ngày hết hạn"
                    name="endDate"
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng chọn ngày hết hạn!',
                      },
                    ]}
                  >
                    <DatePicker style={{ width: '100%' }} />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={isLicenseExists} // Disable button nếu License đã tồn tại
                    >
                      Thêm License
                    </Button>
                  </Form.Item>
                </Form>
              </Modal>
            </div>
          </Tabs.TabPane>
        </Tabs>
      </Modal>

      <Modal
        title="Danh sách các users"
        visible={isUsersModalVisible}
        onCancel={handleUsersModalCancel}
        footer={null}
        centered
        bodyStyle={{
          padding: '20px',
        }}
      >
        <div
          style={{
            fontWeight: 'bold',
            color: '#333',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: '16px',
            marginBottom: '15px',
          }}
        >
          <p>
            License name: {currentRecord?.licenses?.licenseName}{' '}
            <input
              type="number"
              value={inputValue}
              onChange={handleInputChange}
              style={{
                marginRight: '5px',
                width: '50px',
                border: '1px solid #EEEEEE',
                fontSize: '14px',
                textAlign: 'center',
              }}
            />
            users
          </p>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '20px',
            marginBottom: '20px',
          }}
        >
          <div style={{ flex: 1 }}>
            <strong
              style={{ color: '#555', fontSize: '14px', display: 'block' }}
            >
              Active Date:
            </strong>
            <DatePicker
              style={{
                width: '100%',
                marginTop: '5px',
                borderColor: '#d9d9d9',
                backgroundColor: '#f5f5f5',
                cursor: 'not-allowed',
                borderRadius: '5px',
              }}
              value={
                currentLicense?.activeDate
                  ? dayjs(currentLicense.activeDate).utc()
                  : null
              }
              disabled
              format="DD/MM/YYYY"
              placeholder="Active Date"
            />
          </div>
          <div style={{ flex: 1 }}>
            <strong
              style={{ color: '#555', fontSize: '14px', display: 'block' }}
            >
              Expire Date:
            </strong>
            <DatePicker
              style={{
                width: '100%',
                marginTop: '5px',
                borderColor: '#4CAF50',
                backgroundColor: '#fff',
                borderRadius: '5px',
              }}
              value={
                currentLicense?.expiredate
                  ? dayjs(currentLicense.expiredate).utc()
                  : null
              }
              onChange={handleDateChange}
              format="DD/MM/YYYY"
              placeholder="Expire Date"
            />
          </div>
        </div>

        {/* Form thêm user mới */}
        {isAddingLicense && (
          <div
            style={{
              position: 'absolute',
              top: '20%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '300px',
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              zIndex: 1000,
            }}
          >
            <Button
              icon={<CloseCircleOutlined />}
              onClick={handleCloseAddLicense}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                border: 'none',
                background: 'transparent',
                fontSize: '18px',
                color: '#f00',
              }}
            />
            <h3 style={{ textAlign: 'center', marginBottom: '15px' }}>
              Thêm mới user
            </h3>
            <Input
              value={newLicense}
              onChange={e => setNewLicense(e.target.value)}
              placeholder="Vui lòng nhập tên user"
              style={{
                width: '100%',
                marginBottom: '15px',
                borderRadius: '5px',
                padding: '8px',
              }}
            />
            <Button
              type="primary"
              onClick={handleSaveLicense}
              style={{ width: '100%' }}
            >
              Thêm
            </Button>
          </div>
        )}

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '10px',
            marginBottom: '20px',
            maxHeight: '300px',
            overflowY: 'auto',
          }}
        >
          {usersList.map((user, index) => (
            <div
              key={index}
              style={{
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                backgroundColor: '#f9f9f9',
                color: '#333',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              {user.name}
            </div>
          ))}
        </div>

        {/* Nút lưu */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            type="primary"
            onClick={handleUpdateExpireDate}
            style={{ width: '150px' }}
          >
            Lưu
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default AdminOrganizations
